/**
 * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
 * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
 *
 * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
 */

/**
 * Snapshots a reactive state value in Svelte >=5
 * @param {Proxy<*>} value
 * @returns {*} - plain JS value of the parameter
 */
export function stateSnapshot(value) {
    return $state.snapshot(value);
}
